import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export const ModuleIntroduction = ({ data, uploadFileAction, editing, className, onChange }: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const moduleClasses = clsx({ ...className.module }, 'relative');
  const containerClasses = clsx({ ...className.container }, 'px-0', 'relative', 'c-module-menu__inner');
  const imgWrapperClasses = clsx('o-image', 'c-app__outside-content', {
    'u-margin-bottom-negative-xxl': content.field_image_pos_vertical === 2,
  });
  const imageId = getRelatedEntityIds(data, 'field_image')[0];

  return (
    <div className={moduleClasses} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={imgWrapperClasses}>
        <EditablePictureContainer
          entityType={data.type}
          fieldName="relationships.field_image"
          entityId={imageId}
          editing={editing}
          onChangeImage={onChange}
          onUpload={uploadFileAction}
          proportions="4:1"
        />
      </div>
      <div className={containerClasses} style={{ zIndex: 3 }}>
        <div className="row no-gutters">
          <div className="col col-12 col-lg-8">
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
              className={{
                'u-margin-top-sm': content.field_image_pos_vertical === 1,
                'u-margin-top-md': content.field_image_pos_vertical === 2,
              }}
              toolbarControls={[
                'bold',
                'italic',
                'headlineOne',
                'headlineTwo',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'sup',
                'secondaryColor',
              ]}
            />
          </div>
          <div className="col col-12 col-lg-8 o-field-text">
            <EditableField
              hide={content.field_hide_text}
              entityType={data.type}
              fieldName="attributes.field_text.value"
              data={content.field_text && content.field_text.value}
              editing={editing}
              onChange={onChange}
              className="u-margin-top-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleIntroduction;
